/* <summary>
date: 25-11-2022
Name: GM
description: Page Added to ad UI Reducer
<summary>*/
import { createSlice } from "@reduxjs/toolkit";
import { COURSE } from "../Helpers/Enums";

const initialState = {
  showNavBar: true,
  isLoading: false,
  showLoginSignupModal: false,
  showToast: false,
  toastMessage: "",
  toastType: 0,
  showHeaderOnSmallScreen: false,
  showActionModal: false,
  actionModalTitle: "",
  actionModalText: "",
  showPromptModal: false,
  promptModalText: "",
  searchQuery: "",

  categoryBubbles: [],
  tagBubbles: [],
  rankBubbles: [],
  designationBubbles: [],
  courseStatus: COURSE.STATUS.ASSIGNED_COURSES,
};

const uiReducerSlice = createSlice({
  initialState,
  name: "ui",
  reducers: {
    ToggleNavBar(state) {
      state.showNavBar = !state.showNavBar;
    },

    ToggleLoader(state, action) {
      state.isLoading = action.payload; //payload will be true or false
    },

    ToggleLoginSignupModal(state, action) {
      state.showLoginSignupModal = action.payload; // Set showLoginSignupModal to the value provided in the payload
      if (action.payload) {
        state.showHeaderOnSmallScreen = false; // Hide header if modal is shown
      }
    },

    ShowToastModal(state, action) {
      const { toastMessage, toastType } = action.payload;
      state.toastMessage = toastMessage;
      state.toastType = toastType;
      state.showToast = true;
    },

    CloseToastModal(state, _action) {
      state.showToast = false;
    },

    ToggleHeaderOnSmallScreen(state) {
      state.showHeaderOnSmallScreen = !state.showHeaderOnSmallScreen;
    },

    ToggleSessionTimeoutAlert(state) {
      state.showActionModal = !state.showActionModal;
    },

    ToggleActionModal(state, action) {
      if (!state.showActionModal) {
        state.showActionModal = true;
        state.actionModalTitle = action.payload.title;
        state.actionModalText = action.payload.text;
      }
    },

    // TogglePromptModal(state, action) {
    //   state.showPromptModal = !state.showPromptModal;
    //   state.promptModalText = action.payload;
    // },

    setSearchQuery(state, action) {
      state.searchQuery = action.payload;
    },

    setCategoryBubbles(state, action) {
      state.categoryBubbles = action.payload;
    },

    setTagBubbles(state, action) {
      state.tagBubbles = action.payload;
    },

    setRankBubbles(state, action) {
      state.rankBubbles = action.payload;
    },

    setCourseStatus(state, action) {
      state.courseStatus = action.payload;
    },

    setDesignationBubbles(state, action) {
      state.designationBubbles = action.payload;
    },
  },
});

export const {
  ToggleNavBar,
  ToggleLoader,
  ToggleLoginSignupModal,
  ShowToastModal,
  CloseToastModal,
  ToggleHeaderOnSmallScreen,
  ToggleSessionTimeoutAlert,
  ToggleActionModal,
  TogglePromptModal,
  setSearchQuery,
  setCategoryBubbles,
  setTagBubbles,
  setRankBubbles,
  setCourseStatus,
  setDesignationBubbles,
} = uiReducerSlice.actions;

export default uiReducerSlice.reducer;
